import React, { useEffect, useState } from 'react';
import './Blog.css'
import HomeBlog from '../../FakeData/HomeBlog';
import AOS from 'aos';
import 'aos/dist/aos.css';
const Blog = () => {

    const [blogs, setBlogs] = useState(HomeBlog);

    useEffect(()=>{
        AOS.init({duration:1000})
    })
    

    return (
       <div className="blogs blg">
            <div className="container">
            <div className="row ">
            {
                blogs.map(blogs =><BlogItem blog={blogs}></BlogItem>)
            }
        </div>
        </div>
       </div>
    );
};



const BlogItem =(props) =>{

    const {blogAddress , blogImg , blogName} = props.blog;

    return(
        <div className="col-md-4 col-sm-6 col-12 blogs-area bls">
            <div data-aos="fade-up">
                <div class="card-deck">
                    <div class="card blog-content">
                        <img src={blogImg} class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h5 class="card-title text-center"> {blogName} </h5>
                        </div>
                        <div class="card-footer">
                            <a class="blog-btn" href={blogAddress}
                                target="_blank">Read Blog</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default Blog;